import React from 'react';
import {
  Box,
  Container,
  Typography,
  Paper,
  Button,
} from '@mui/material';
import {
  Email,
  ContactMail,
} from '@mui/icons-material';
import Navigation from './Navigation';

const Contact: React.FC = () => {
  return (
    <Box>
      <Navigation />
      
      <Container maxWidth="md" sx={{ py: 8 }}>
        <Paper elevation={3} sx={{ p: 8, textAlign: 'center' }}>
          <ContactMail sx={{ fontSize: 80, color: 'primary.main', mb: 3 }} />
          
          <Typography variant="h3" component="h1" gutterBottom sx={{ fontWeight: 'bold', color: 'primary.main' }}>
            Get in Touch
          </Typography>
          
          <Typography variant="h6" sx={{ mb: 4, color: 'text.secondary', lineHeight: 1.6 }}>
            Feel free to ask me any questions! I'd love to hear from you.
          </Typography>
          
          <Box sx={{ 
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'center', 
            gap: 2, 
            mb: 4,
            p: 3,
            backgroundColor: '#f5f5f5',
            borderRadius: 2,
          }}>
            <Email sx={{ color: 'primary.main', fontSize: 30 }} />
            <Typography variant="h5" sx={{ fontWeight: 'bold', color: 'primary.main' }}>
              raymond@raymondjones.dev
            </Typography>
          </Box>
          
          <Button
            variant="contained"
            href="mailto:raymond@raymondjones.dev"
            sx={{
              px: 6,
              py: 2,
              fontSize: '1.2rem',
              textTransform: 'none',
              fontWeight: 'bold',
              borderRadius: 2,
            }}
          >
            Send Email
          </Button>
        </Paper>
      </Container>
    </Box>
  );
};

export default Contact;